<template>
    <div>
        <template v-for="(item, index) in options">
            <template v-if="values.includes(item.value)">
                <el-tag v-if="(item.elTagType && item.elTagType !== 'default')"
                        :disable-transitions="true" :key="item.value + ''" :index="index"
                        :type="item.elTagType" :color="item&&item.color" :class="item.elTagClass">
                    {{ item.label + " " }}</el-tag>
                <span v-else :key="item.value" :index="index" :class="item.elTagClass">{{ item.label + " " }}</span>
            </template>
        </template>
        <template v-if="unmatch && showValue">
            {{ unmatchArray | handleArray }}
        </template>
    </div>
</template>
<script >
// 记录未匹配的项
export default {
    props: {
        options: {
            type: Array,
            default: null,
        },
        // 当前的值
        value: [Number, String, Array],
        // 当未找到匹配的数据时，显示value
        showValue: {
            type: Boolean,
            default: true,
        },
        separator: {
            type: String,
            default: ",",
        }
    },
    data:{
        unmatchArray:[],
    },
    computed: {
        values() {
            if (this.value === null || typeof this.value === 'undefined' || this.value === '') return [];
            return Array.isArray(this.value) ? this.value.map(item => item) : [this.value]
        },
        unmatch(){
            this.unmatchArray = [];
            // 没有value不显示
            if (this.value === null || typeof this.value === 'undefined' || this.value === '' || this.options.length === 0) return false
            // 传入值为数组
            let unmatch = false // 添加一个标志来判断是否有未匹配项
            this.values.forEach(item => {
                if (!this.options.some(v => v.value === item)) {
                    this.unmatchArray.push(item)
                    unmatch = true // 如果有未匹配项，将标志设置为true
                }
            })
            return unmatch // 返回标志的值
        }
    },
    methods:{
        handleArray(array) {
            if (array.length === 0) return "";
            return array.reduce((pre, cur) => {
                return pre + " " + cur;
            });
        }
    }
}
</script>
<style scoped>
.el-tag+.el-tag {
    margin-left: 10px;
}
.tag1{
    color: #fff;
    background-color: #FE7C78;
    border-radius: 12px;
}
.tag2{
    color: #fff;
    background-color: #FBB157;
    border-radius: 12px;
}
.tag3{
    color: #fff;
    background-color: #9884FB;
    border-radius: 12px;
}
.tag4{
    color: #fff;
    background-color: #4D80FE;
    border-radius: 12px;
}
.tag5{
    color: #fff;
    background-color: #8ef580;
    border-radius: 12px;
}
</style>





// WEBPACK FOOTER //
// src/Hcomponents/DictTag/index.vue